import React from "react";
import axios from "axios";
import { getCode } from "../libs/GetCods";
import { getConfig } from "../libs/GetConfig";
import { PopupSettings } from "@widgets/commonpopup/PopupSettings";
import dayjs from "dayjs";
import { global, globalMenu, trackMenuInit } from "@shared/libs/Global";
import { showDialog } from "@widgets/CommonDialog";
import { showPopupModal } from "@widgets/CommonModal";
import ReportViewer from "@widgets/commonpopup/ReportViewer";
import * as dfns from "date-fns";
import { RowNode } from "ag-grid-community";
import { fnGetDataSet, fnGetTableById } from "@shared/api/restApi";

export const getCodeData = async (
  code: string,
  sql: string,
  addEmpty?: boolean
) => {
  let data: any;
  let param: string = sql;
  if (code != "") param = getCode(code);
  if (param != "") {
    try {
      const params = {
        id: "com_CommonMapper_02",
        params: {
          sql: param,
          cd_firm: global.getState().userInfo.cd_firm,
          cd_biz: global.getState().userInfo.cd_biz,
          cd_dept: global.getState().userInfo.cd_dept,
          cd_emp: global.getState().userInfo.cd_emp,
          cd_user: global.getState().userInfo.cd_user,
          cd_exchange: global.getState().userInfo.cd_exchange,
          fg_pos: global.getState().userInfo.fg_pos,
          fg_role: global.getState().userInfo.fg_role,
          cd_gra: global.getState().userInfo.cd_gra,
          cd_gp: global.getState().userInfo.cd_gp,
          fg_user: global.getState().userInfo.fg_user,
          cd_cust: global.getState().userInfo.cd_cust,
        },
      };

      const response = await axios.post("/snotes/getTablebySql", params, {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      });
      data = response.data[0];

      if (addEmpty) {
        data.unshift({ CODE: "", NAME: "" });
      }
    } catch (error) {
      console.error("API 호출 실패1", error);
      throw error;
    }
  }
  return data;
};

export const getconfigData = async (code: string) => {
  let data: any;
  let param: string = code;
  if (code != "") param = getConfig(code);
  if (param != "") {
    try {
      const params = {
        id: "com_CommonMapper_02",
        params: {
          sql: param,
        },
      };

      const response = await axios.post("/snotes/getTablebySql", params, {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      });
      data = response.data[0];
    } catch (error) {
      console.error("API 호출 실패1", error);
      throw error;
    }
  }
  return data;
};

export const getTablebySql = async (sqlAndParams: any) => {
  try {
    const params = {
      id: "com_CommonMapper_02",
      params: sqlAndParams,
    };

    const response = await axios.post("/snotes/getTablebySql", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });
    return response.data[0];
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

/** * prefix없는 채번 표준!!
 * * param: cd_module, no_line, dt, cd_menu
 */
export const getAutoSlip = async (
  cd_module: string,
  no_line: number,
  dt: string,
  cd_menu?: string
): Promise<string | null> => {
  const cd_prefix = "";

  const params = {
    id: "com_CommonMapper_01",
    params: {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_module: cd_module || globalMenu.getState().activeMenuInfo.cd_module,
      no_line,
      cd_prefix,
      dt,
      cd_menu: cd_menu || globalMenu.getState().activeMenuInfo.cd_menu,
      cd_user: global.getState().userInfo.cd_user,
    },
  };

  try {
    const response = await axios.post("/snotes/getDataSet", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    // 데이터 유효성 검사 및 안전 반환
    if (response.data && response.data[0] && response.data[0][0]?.no_slip) {
      const noSlip = response.data[0][0].no_slip;

      return noSlip; // 정상 반환
    } else {
      console.error("유효하지 않은 데이터 형식:", response.data);
      return null; // 유효하지 않은 응답 처리
    }
  } catch (error) {
    console.error("API 호출 실패:", error);
    throw error; // 호출부에서 에러를 처리하도록 throw
  }
};

/** * prefix없는 채번 표준!!
 * * param: cd_column, cd_module, no_line, dt, cd_menu, girdrefs[], inserts[], formrefs[]
 */
export const applyAutoSlip = async (params: {
  cd_column: string;
  cd_module?: string;
  no_line: number;
  dt: string;
  cd_menu?: string;
  girdrefs?: any[];
  inserts?: any[];
  formrefs?: any[];
}) => {
  try {
    const noSlip = await getAutoSlip(
      globalMenu.getState().activeMenuInfo.cd_module || params.cd_module || "",
      params.no_line,
      params.dt,
      globalMenu.getState().activeMenuInfo.cd_menu
    );
    if (typeof noSlip === "string" && noSlip != "") {
      params.girdrefs?.forEach((grid) => {
        const filterd: any[] = [];
        grid.current?.forEachNode((node: any) => {
          if (
            node.data[params.cd_column] == "" ||
            node.data[params.cd_column] == null ||
            node.data[params.cd_column] == undefined
          ) {
            filterd.push(node);
          }
        });
        filterd.forEach((row) => {
          row.setDataValue(params.cd_column, noSlip, "noEvent");
        });
      });
      params.formrefs?.forEach((form) => {
        form.current?.setDataValue(params.cd_column, noSlip, "noEvent");
      });
    } else {
      throw new Error();
    }
    return noSlip;
  } catch (error) {
    showDialog("error", "전표채번에 실패했습니다.");
  }
};

// 반환 타입 정의
export const getNoSlip = async (
  cd_module: string,
  no_line: number,
  cd_prefix: string,
  dt: string,
  cd_menu?: string
): Promise<string | null> => {
  const params = {
    id: "com_CommonMapper_01",
    params: {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_module: cd_module || globalMenu.getState().activeMenuInfo.cd_module,
      no_line,
      cd_prefix,
      dt,
      cd_menu: cd_menu || globalMenu.getState().activeMenuInfo.cd_menu,
      cd_user: global.getState().userInfo.cd_user,
    },
  };

  try {
    const response = await axios.post("/snotes/getDataSet", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    // 데이터 유효성 검사 및 안전 반환
    if (response.data && response.data[0] && response.data[0][0]?.no_slip) {
      const noSlip = response.data[0][0].no_slip;

      return noSlip; // 정상 반환
    } else {
      console.error("유효하지 않은 데이터 형식:", response.data);
      return null; // 유효하지 않은 응답 처리
    }
  } catch (error) {
    console.error("API 호출 실패:", error);
    throw error; // 호출부에서 에러를 처리하도록 throw
  }
};

/**
 * sp_mas_bsn_get 호출: 제품/SN 바코드 채번
 * select no_bsn from sp_mas_bsn_get(
 *   :cd_firm, :cd_bsn, :cd_item, :cd_item_cust,
 *   :dt, :qt_unit, :qt, :yn_save, :dc_param_exc
 * )
 * qt_unit: 단위수량, qt: 생성수량
 */
export const getbsngetList = async (
  cd_bsn: string,
  cd_item: string,
  cd_item_cust: string,
  dt: string,
  qt_unit: number,
  qt: number,
  yn_save: string,
  dc_param_exc: string
): Promise<any[]> => {
  const params = {
    id: "sp_mas_bsn_get_list",
    params: {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_bsn,
      cd_item,
      cd_item_cust,
      dt,
      qt_unit,
      qt,
      yn_save,
      dc_param_exc,
    },
  };

  try {
    const response = await axios.post("/snotes/getDataSet", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });
    const rows = response?.data?.[0];
    if (Array.isArray(rows) && rows.length > 0) {
      return rows;
    }
    console.error(
      "sp_mas_bsn_get 반환 데이터가 유효하지 않습니다:",
      response?.data
    );
    return [];
  } catch (error) {
    console.error("sp_mas_bsn_get 호출 실패:", error);
    throw error;
  }
};

export const getbsnget = async (
  cd_bsn: string,
  cd_item: string,
  cd_item_cust: string,
  dt: string,
  qt_unit: number,
  qt: number,
  yn_save: string,
  dc_param_exc: string
): Promise<string | null> => {
  const rows = await getbsngetList(
    cd_bsn,
    cd_item,
    cd_item_cust,
    dt,
    qt_unit,
    qt,
    yn_save,
    dc_param_exc
  );
  return rows[0]?.no_bsn || null;
};

const processForm = (form: any[]) => {
  const controlData: any = {};

  form?.forEach((col: any) => {
    let param: string = col.cd_param;
    let value: string = col.cd_value;
    let p: string[] = param.split(",");

    if (
      col.tp_ctrl === "SnComboTextBox" ||
      col.tp_ctrl === "SnYearWeekPicker" ||
      col.tp_ctrl === "SnPeriodTimeBox"
    ) {
      if (value) {
        let v = value.split(",");
        col[p[0].trim()] = v[0]?.trim() || "";
        col[p[1].trim()] = v[1]?.trim() || "";
        controlData[p[0].trim()] = col[p[0].trim()];
        controlData[p[1].trim()] = col[p[1].trim()];
      } else {
        p.forEach((k) => {
          col[k.trim()] = "";
          controlData[k.trim()] = "";
        });
      }
    } else if (
      col.tp_ctrl === "SnDateBox" ||
      col.tp_ctrl === "SnDateMonthBox" ||
      col.tp_ctrl === "SnDateYearBox"
    ) {
      controlData[col.cd_param] = getConvertedDate(value);
    } else if (
      col.tp_ctrl === "SnPeriodBox" ||
      col.tp_ctrl === "SnPeriodMonthBox" ||
      col.tp_ctrl === "SnPeriodMonthBoxPop" ||
      col.tp_ctrl == "SnYearPeriodBox"
    ) {
      if (value) {
        let v = value.split(",");
        col[p[0].trim()] = getConvertedDate(v[0]);
        col[p[1].trim()] = getConvertedDate(v[1]);
        controlData[p[0].trim()] = col[p[0].trim()];
        controlData[p[1].trim()] = col[p[1].trim()];
      } else {
        p.forEach((k) => {
          col[k.trim()] = "";
          controlData[k.trim()] = "";
        });
      }
    } else if (
      col.tp_ctrl === "SnComboPeriodBox" ||
      col.tp_ctrl === "SnCheckPeriodBox"
    ) {
      if (value) {
        let v = value.split(",");
        col[p[0].trim()] = v[0];
        col[p[1].trim()] = getConvertedDate(v[1]);
        col[p[2].trim()] = getConvertedDate(v[2]);
        controlData[p[0].trim()] = col[p[0].trim()];
        controlData[p[1].trim()] = col[p[1].trim()];
        controlData[p[2].trim()] = col[p[2].trim()];
      } else {
        p.forEach((k) => {
          col[k.trim()] = "";
          controlData[k.trim()] = "";
        });
      }
    } else {
      controlData[col.cd_param] = value ? convertLoginData(value) : "";
    }
  });

  return { form, controlData };
};

/**
 * 조회조건(SearchPanel) 컨트롤 설정(cd_param / cd_value / tp_ctrl)으로 초기 formData 를 만든다.
 * getInitForm / getInitFormData 의 초기값 계산과 SearchPanel 의 "조회조건 초기화" 버튼이 같이 쓴다.
 */
export const buildSearchFormData = (controls?: any[] | null) => {
  const main: any = {};
  main["cd_firm"] = global.getState().userInfo.cd_firm;

  (controls || []).forEach((col: any) => {
    const param: string = col?.cd_param || "";
    const value: string = col?.cd_value;
    const p: string[] = param.split(",");
    if (!param) return;

    if (
      col.tp_ctrl == "SnComboTextBox" ||
      col.tp_ctrl == "SnYearWeekPicker" ||
      col.tp_ctrl == "SnPeriodTimeBox"
    ) {
      if (value && value.length >= 1) {
        const v: string[] = value.split(",");
        main[p[0].trim()] = convertLoginData(v[0].trim());
        main[p[1].trim()] = convertLoginData(v[1].trim());
      } else {
        main[p[0].trim()] = "";
        main[p[1].trim()] = "";
      }
    } else if (
      col.tp_ctrl == "SnDateBox" ||
      col.tp_ctrl == "SnDateMonthBox" ||
      col.tp_ctrl == "SnDateYearBox"
    ) {
      main[col.cd_param] = getConvertedDate(value);
    } else if (
      col.tp_ctrl == "SnPeriodBox" ||
      col.tp_ctrl == "SnPeriodMonthBox" ||
      col.tp_ctrl == "SnPeriodMonthBoxPop" ||
      col.tp_ctrl == "SnYearPeriodBox"
    ) {
      if (value && value.length >= 1) {
        const v: string[] = value.split(",");
        main[p[0].trim()] = getConvertedDate(v[0].trim());
        main[p[1].trim()] = getConvertedDate(v[1].trim());
      } else {
        main[p[0].trim()] = "";
        main[p[1].trim()] = "";
      }
    } else if (
      col.tp_ctrl == "SnComboPeriodBox" ||
      col.tp_ctrl == "SnCheckPeriodBox"
    ) {
      if (value && value.length >= 1) {
        const v: string[] = value.split(",");
        main[p[0].trim()] = convertLoginData(v[0].trim());
        main[p[1].trim()] = getConvertedDate(v[1].trim());
        main[p[2].trim()] = getConvertedDate(v[2].trim());
      } else {
        main[p[0].trim()] = "";
        main[p[1].trim()] = "";
        main[p[2].trim()] = "";
      }
    } else {
      if (
        value == "global" &&
        global.getState().userInfo.hasOwnProperty(col.cd_param)
      ) {
        main[col.cd_param] = global.getState().userInfo[col.cd_param];
      } else {
        main[col.cd_param] = value ? convertLoginData(value) : "";
      }
    }
  });
  return main;
};

/**
 * @deprecated 사용하지 마세요. getInitFormData를 사용하세요.
 */
export const getInitForm = async (addFormdata?: any) => {
  const params = {
    id: "com_CommonMapper_06",
    params: {
      cd_menu:
        addFormdata && "cd_menu" in addFormdata
          ? addFormdata.cd_menu
          : globalMenu.getState().activeMenuInfo.cd_menu,
      cd_module:
        addFormdata && "cd_module" in addFormdata
          ? addFormdata.cd_module
          : globalMenu.getState().activeMenuInfo.cd_module,
      cd_firm: global.getState().userInfo.cd_firm,
      cd_user: global.getState().userInfo.cd_user,
    },
  };
  try {
    // 초기화가 끝나기 전 툴바 클릭을 막기 위해 진행 상태를 기록한다
    const response = await trackMenuInit(params.params.cd_menu, () =>
      axios.post("/snotes/getDataSet", params, {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      })
    );
    const data = response.data;

    // searchPanel 내용 (초기값은 SearchPanel 초기화 버튼과 같은 로직을 쓴다)
    const main: any = buildSearchFormData(data[0]);

    // grid 내용
    const grid =
      data[1] != null &&
      data[1].reduce((acc: any, curr: any) => {
        const { cd_grid } = curr;
        if (acc[cd_grid]) acc[cd_grid].push(curr);
        else acc[cd_grid] = [curr];
        return acc;
      }, {});

    // freeform 내용
    const form =
      data[2] != null &&
      data[2].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});

    const header =
      data[3] != null &&
      data[3].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});

    let freeform1ControlData: any = {};
    const freeform1 = form.freeform1;
    {
      // freeform 날짜 변환
      freeform1 != null &&
        freeform1.length > 0 &&
        freeform1.map((col: any) => {
          let param: string = col.cd_param;
          let value: string = col.cd_value;
          let p: string[] = param.split(",");

          if (
            col.tp_ctrl == "SnComboTextBox" ||
            col.tp_ctrl == "SnYearWeekPicker" ||
            col.tp_ctrl == "SnPeriodTimeBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = v[1].trim();
              freeform1ControlData[p[0].trim()] = v[0].trim();
              freeform1ControlData[p[1].trim()] = v[1].trim();
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnDateBox" ||
            col.tp_ctrl == "SnDateMonthBox" ||
            col.tp_ctrl == "SnDateYearBox"
          ) {
            freeform1ControlData[col.cd_param] = getConvertedDate(value);
          } else if (
            col.tp_ctrl == "SnPeriodBox" ||
            col.tp_ctrl == "SnPeriodMonthBox" ||
            col.tp_ctrl == "SnPeriodMonthBoxPop" ||
            col.tp_ctrl == "SnYearPeriodBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = getConvertedDate(v[0].trim());
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              freeform1ControlData[p[0].trim()] = getConvertedDate(v[0].trim());
              freeform1ControlData[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnComboPeriodBox" ||
            col.tp_ctrl == "SnCheckPeriodBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              col[p[2].trim()] = getConvertedDate(v[2].trim());
              freeform1ControlData[p[0].trim()] = v[0].trim();
              freeform1ControlData[p[1].trim()] = getConvertedDate(v[1].trim());
              freeform1ControlData[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              col[p[2].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
              freeform1ControlData[p[2].trim()] = "";
            }
          } else {
            freeform1ControlData[col.cd_param] = value
              ? convertLoginData(value)
              : "";
          }
        });
    }
    form.freeform1 = freeform1;
    form.freeform1ControlData = freeform1ControlData;

    let rtn = {
      formData: main,
      formControlData: data[0],
      grid: grid,
      form: form,
      header: header,
    };
    return rtn;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

export const getInitFormData = async (addFormdata?: any) => {
  const params = {
    cd_menu:
      addFormdata && "cd_menu" in addFormdata
        ? addFormdata.cd_menu
        : globalMenu.getState().activeMenuInfo.cd_menu,
    cd_module:
      addFormdata && "cd_module" in addFormdata
        ? addFormdata.cd_module
        : globalMenu.getState().activeMenuInfo.cd_module,
    cd_firm:
      addFormdata && "cd_firm" in addFormdata
        ? addFormdata.cd_firm
        : global.getState().userInfo.cd_firm,
    cd_user:
      addFormdata && "cd_user" in addFormdata
        ? addFormdata.cd_user
        : global.getState().userInfo.cd_user,
  };
  try {
    // 초기화가 끝나기 전 툴바 클릭을 막기 위해 진행 상태를 기록한다
    const response = await trackMenuInit(params.cd_menu, () =>
      axios.post("/snotes/getInitForm", params, {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      })
    );
    const data = response.data;
    // searchPanel 내용 (초기값은 SearchPanel 초기화 버튼과 같은 로직을 쓴다)
    const main: any = buildSearchFormData(data[0]);

    // grid 내용
    const grid =
      data[1] != null &&
      data[1].reduce((acc: any, curr: any) => {
        const { cd_grid } = curr;
        if (acc[cd_grid]) acc[cd_grid].push(curr);
        else acc[cd_grid] = [curr];
        return acc;
      }, {});

    // freeform 내용
    const form =
      data[2] != null &&
      data[2].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});
    const header =
      data[3] != null &&
      data[3].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});
    let freeform1ControlData: any = {};
    const freeform1 = form.freeform1;
    {
      // freeform 날짜 변환
      freeform1 != null &&
        freeform1.length > 0 &&
        freeform1.map((col: any) => {
          let param: string = col.cd_param;
          let value: string = col.cd_value;
          let p: string[] = param.split(",");

          if (
            col.tp_ctrl == "SnComboTextBox" ||
            col.tp_ctrl == "SnYearWeekPicker" ||
            col.tp_ctrl == "SnPeriodTimeBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = v[1].trim();
              freeform1ControlData[p[0].trim()] = v[0].trim();
              freeform1ControlData[p[1].trim()] = v[1].trim();
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnDateBox" ||
            col.tp_ctrl == "SnDateMonthBox" ||
            col.tp_ctrl == "SnDateYearBox"
          ) {
            freeform1ControlData[col.cd_param] = getConvertedDate(value);
          } else if (
            col.tp_ctrl == "SnPeriodBox" ||
            col.tp_ctrl == "SnPeriodMonthBox" ||
            col.tp_ctrl == "SnPeriodMonthBoxPop" ||
            col.tp_ctrl == "SnYearPeriodBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = getConvertedDate(v[0].trim());
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              freeform1ControlData[p[0].trim()] = getConvertedDate(v[0].trim());
              freeform1ControlData[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnComboPeriodBox" ||
            col.tp_ctrl == "SnCheckPeriodBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              col[p[2].trim()] = getConvertedDate(v[2].trim());
              freeform1ControlData[p[0].trim()] = v[0].trim();
              freeform1ControlData[p[1].trim()] = getConvertedDate(v[1].trim());
              freeform1ControlData[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              col[p[2].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
              freeform1ControlData[p[2].trim()] = "";
            }
          } else {
            freeform1ControlData[col.cd_param] = value
              ? convertLoginData(value)
              : "";
          }
        });
    }
    form.freeform1 = freeform1;
    form.freeform1ControlData = freeform1ControlData;

    Object.keys(form).forEach((key) => {
      if (!key.startsWith("freeform")) return;

      const freeform = form[key];
      if (!Array.isArray(freeform)) return;

      const { form: updatedFreeform, controlData } = processForm(freeform);

      form[key] = updatedFreeform;
      form[`${key}Data`] = controlData;
    });

    Object.keys(header).forEach((key) => {
      const headerform = header[key];
      if (!Array.isArray(headerform)) return;

      const { form: updatedheaderform, controlData } = processForm(headerform);

      header[key] = { controls: updatedheaderform, data: controlData };
    });

    let rtn = {
      formData: main,
      formControlData: data[0],
      grid: grid,
      form: form,
      header: header,
    };
    return rtn;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

/**
 * @deprecated 사용하지 마세요. getInitPopUpData를 사용하세요.
 */
export const getInitPopUp = async (cd_menu: string, addFormdata?: {}) => {
  const params = {
    id: "com_CommonMapper_08",
    params: {
      cd_menu: cd_menu,
      cd_firm: global.getState().userInfo.cd_firm,
      cd_module: globalMenu.getState().activeMenuInfo.cd_module,
    },
  };
  try {
    const response = await axios.post("/snotes/getDataSet", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });
    const data = response.data;
    // let main = Object.assign(addFormdata || {});
    let main: any = {};
    main["cd_firm"] = global.getState().userInfo.cd_firm;

    // searchPanel 내용
    let formdata: any[];
    formdata = data[0];
    {
      formdata.length > 0 &&
        formdata.map((col) => {
          if (
            col.tp_ctrl == "SnComboTextBox" ||
            col.tp_ctrl == "SnYearWeekPicker" ||
            col.tp_ctrl == "SnPeriodTimeBox"
          ) {
            let param: string = col.cd_param;
            let value: string = col.cd_value;
            let p: string[] = param.split(",");

            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = convertLoginData(v[0].trim());
              main[p[1].trim()] = convertLoginData(v[1].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
            }
          }
          if (
            col.tp_ctrl == "SnPeriodBox" ||
            col.tp_ctrl == "SnPeriodMonthBox" ||
            col.tp_ctrl == "SnPeriodMonthBoxPop" ||
            col.tp_ctrl == "SnYearPeriodBox"
          ) {
            let param: string = col.cd_param;
            let value: string = col.cd_value;
            let p: string[] = param.split(",");
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = getConvertedDate(v[0].trim());
              main[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnComboPeriodBox" ||
            col.tp_ctrl == "SnCheckPeriodBox"
          ) {
            let param: string = col.cd_param;
            let value: string = col.cd_value;
            let p: string[] = param.split(",");
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = v[0].trim();
              main[p[1].trim()] = getConvertedDate(v[1].trim());
              main[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
              main[p[2].trim()] = "";
            }
          } else {
            // main[col.cd_param] = col.cd_value != null? col.cd_clas : '';
            main[col.cd_param] = col.cd_value
              ? convertLoginData(col.cd_value)
              : "";
          }
        });
    }
    let init = Object.assign({}, main);
    init.cd_firm = "xxxx";

    // grid 내용
    const grid = data[1].reduce((acc: any, curr: any) => {
      const { cd_grid } = curr;
      if (acc[cd_grid]) acc[cd_grid].push(curr);
      else acc[cd_grid] = [curr];
      return acc;
    }, {});

    // freeform 내용
    const form =
      data[2] != null &&
      data[2].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});

    Object.entries(form).forEach(([formKey, formArray]: [string, any]) => {
      // getInitPopUp에서 freeform으로 시작하는 키만 처리하던 로직 때문에,
      //form1/form2/form3 같은 다른 폼 키의 컨트롤 데이터가 생성되지 않는 문제가 있어
      // 모든 배열 형태의 폼을 처리하도록 조건을 완화했습니다.

      if (!Array.isArray(formArray)) return;

      let controlData: any = {};

      formArray.forEach((col: any) => {
        const { cd_param, cd_value: value, tp_ctrl } = col;
        let param = cd_param;
        let val = value;
        let p = param?.split(",") ?? [];

        switch (tp_ctrl) {
          case "SnComboTextBox":
          case "SnYearWeekPicker":
          case "SnPeriodTimeBox":
            if (val && val.length >= 1) {
              let v = val.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = v[1].trim();
              controlData[p[0].trim()] = v[0].trim();
              controlData[p[1].trim()] = v[1].trim();
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              controlData[p[0].trim()] = "";
              controlData[p[1].trim()] = "";
            }
            break;

          case "SnDateBox":
          case "SnDateMonthBox":
          case "SnDateYearBox":
            controlData[cd_param] = getConvertedDate(val);
            break;

          case "SnPeriodBox":
          case "SnPeriodMonthBox":
          case "SnPeriodMonthBoxPop":
          case "SnYearPeriodBox":
            if (val && val.length >= 1) {
              let v = val.split(",");
              col[p[0].trim()] = getConvertedDate(v[0].trim());
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              controlData[p[0].trim()] = getConvertedDate(v[0].trim());
              controlData[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              controlData[p[0].trim()] = "";
              controlData[p[1].trim()] = "";
            }
            break;

          case "SnComboPeriodBox":
            if (val && val.length >= 1) {
              let v = val.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              col[p[2].trim()] = getConvertedDate(v[2].trim());
              controlData[p[0].trim()] = v[0].trim();
              controlData[p[1].trim()] = getConvertedDate(v[1].trim());
              controlData[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              col[p[2].trim()] = "";
              controlData[p[0].trim()] = "";
              controlData[p[1].trim()] = "";
              controlData[p[2].trim()] = "";
            }
            break;

          default:
            controlData[cd_param] = val ? convertLoginData(val) : "";
            break;
        }
      });

      form[`${formKey}ControlData`] = controlData;
    });

    let rtn = {
      initformData: init,
      formData: main,
      formControlData: data[0],
      grid: grid,
      form: form,
    };
    return rtn;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

export const getInitPopUpData = async (cd_menu: string, addFormdata?: {}) => {
  const params = {
    cd_menu: cd_menu,
    cd_firm: global.getState().userInfo.cd_firm,
    cd_module: globalMenu.getState().activeMenuInfo.cd_module,
    cd_user: global.getState().userInfo.cd_user,
  };
  try {
    const response = await axios.post("/snotes/getInitPopUp", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    const data = response.data;
    // let main = Object.assign(addFormdata || {});
    let main: any = {};
    main["cd_firm"] = global.getState().userInfo.cd_firm;

    // searchPanel 내용
    let formdata: any[];
    formdata = data[0];
    {
      formdata.length > 0 &&
        formdata.map((col) => {
          if (
            col.tp_ctrl == "SnComboTextBox" ||
            col.tp_ctrl == "SnYearWeekPicker" ||
            col.tp_ctrl == "SnPeriodTimeBox"
          ) {
            let param: string = col.cd_param;
            let value: string = col.cd_value;
            let p: string[] = param.split(",");

            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = convertLoginData(v[0].trim());
              main[p[1].trim()] = convertLoginData(v[1].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
            }
          }
          if (
            col.tp_ctrl == "SnPeriodBox" ||
            col.tp_ctrl == "SnPeriodMonthBox" ||
            col.tp_ctrl == "SnPeriodMonthBoxPop" ||
            col.tp_ctrl == "SnYearPeriodBox"
          ) {
            let param: string = col.cd_param;
            let value: string = col.cd_value;
            let p: string[] = param.split(",");
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = getConvertedDate(v[0].trim());
              main[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnComboPeriodBox" ||
            col.tp_ctrl == "SnCheckPeriodBox"
          ) {
            let param: string = col.cd_param;
            let value: string = col.cd_value;
            let p: string[] = param.split(",");
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = v[0].trim();
              main[p[1].trim()] = getConvertedDate(v[1].trim());
              main[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
              main[p[2].trim()] = "";
            }
          } else {
            if (
              col.cd_value == "global" &&
              global.getState().userInfo.hasOwnProperty(col.cd_param)
            ) {
              main[col.cd_param] = global.getState().userInfo[col.cd_param];
            } else {
              main[col.cd_param] = col.cd_value
                ? convertLoginData(col.cd_value)
                : "";
            }
          }
        });
    }
    let init = Object.assign({}, main);
    init.cd_firm = "xxxx";

    // grid 내용
    const grid = data[1].reduce((acc: any, curr: any) => {
      const { cd_grid } = curr;
      if (acc[cd_grid]) acc[cd_grid].push(curr);
      else acc[cd_grid] = [curr];
      return acc;
    }, {});

    // freeform 내용
    const form =
      data[2] != null &&
      data[2].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});

    Object.entries(form).forEach(([formKey, formArray]: [string, any]) => {
      if (!formKey.startsWith("freeform") || !Array.isArray(formArray)) return;

      let controlData: any = {};

      formArray.forEach((col: any) => {
        const { cd_param, cd_value: value, tp_ctrl } = col;
        let param = cd_param;
        let val = value;
        let p = param?.split(",") ?? [];

        switch (tp_ctrl) {
          case "SnComboTextBox":
          case "SnYearWeekPicker":
          case "SnPeriodTimeBox":
            if (val && val.length >= 1) {
              let v = val.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = v[1].trim();
              controlData[p[0].trim()] = v[0].trim();
              controlData[p[1].trim()] = v[1].trim();
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              controlData[p[0].trim()] = "";
              controlData[p[1].trim()] = "";
            }
            break;

          case "SnDateBox":
          case "SnDateMonthBox":
          case "SnDateYearBox":
            controlData[cd_param] = getConvertedDate(val);
            break;

          case "SnPeriodBox":
          case "SnPeriodMonthBox":
          case "SnPeriodMonthBoxPop":
          case "SnYearPeriodBox":
            if (val && val.length >= 1) {
              let v = val.split(",");
              col[p[0].trim()] = getConvertedDate(v[0].trim());
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              controlData[p[0].trim()] = getConvertedDate(v[0].trim());
              controlData[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              controlData[p[0].trim()] = "";
              controlData[p[1].trim()] = "";
            }
            break;

          case "SnComboPeriodBox":
            if (val && val.length >= 1) {
              let v = val.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              col[p[2].trim()] = getConvertedDate(v[2].trim());
              controlData[p[0].trim()] = v[0].trim();
              controlData[p[1].trim()] = getConvertedDate(v[1].trim());
              controlData[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              col[p[2].trim()] = "";
              controlData[p[0].trim()] = "";
              controlData[p[1].trim()] = "";
              controlData[p[2].trim()] = "";
            }
            break;

          default:
            if (
              val == "global" &&
              global.getState().userInfo.hasOwnProperty(cd_param)
            ) {
              controlData[cd_param] = global.getState().userInfo[cd_param];
            } else {
              controlData[cd_param] = val ? convertLoginData(val) : "";
            }
            break;
        }
      });

      form[`${formKey}ControlData`] = controlData;
    });

    let rtn = {
      initformData: init,
      formData: main,
      formControlData: data[0],
      grid: grid,
      form: form,
    };
    return rtn;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

export const getInitSheet = async (addFormdata?: {}) => {
  const params = {
    cd_menu: globalMenu.getState().activeMenuInfo.cd_menu,
    cd_firm: global.getState().userInfo.cd_firm,
    cd_user: global.getState().userInfo.cd_user,
  };
  try {
    // 초기화가 끝나기 전 툴바 클릭을 막기 위해 진행 상태를 기록한다
    const response = await trackMenuInit(params.cd_menu, () =>
      axios.post("/snotes/getInitSheet", params, {
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      })
    );
    const data = response.data;

    let main = Object.assign(addFormdata || {});
    main.cd_firm = global.getState().userInfo.cd_firm;
    //temp = Object.assign({cd_firm : '1000'})

    const grid =
      data != null &&
      data.reduce((acc: any, curr: any) => {
        const { cd_grid } = curr;
        if (acc[cd_grid]) acc[cd_grid].push(curr);
        else acc[cd_grid] = [curr];
        return acc;
      }, {});

    let rtn = {
      grid: grid,
    };
    return rtn;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

/**
 * 팝업 title, str_search 조회
 * @param code
 * @param formData
 */
export const getSearchData = (code: string, formData: any) => {
  const popupSetting = PopupSettings[code];

  if (!popupSetting) {
    return {
      title: "",
      selectedData: formData,
      width: undefined,
    };
  }

  const selectedData = { ...formData };
  const { title, str_search, autoSearch, width, height } = popupSetting;
  if (str_search && selectedData.hasOwnProperty(str_search)) {
    selectedData["str_search"] = selectedData[str_search]
      ? selectedData[str_search]
      : "";
  }

  return {
    title: title || "",
    selectedData: selectedData,
    autoSearch: autoSearch,
    width: width,
    height: height,
  };
};

export const getMultiPopupColumns = (code: string) => {
  const popupSetting = PopupSettings[code];

  if (!popupSetting) {
    return [];
  }

  const columns = popupSetting.columns;
  return columns.slice(0, 2); // 앞의 2개만 반환
};

/**
 * 날짜코드 변환 함수
 * @param code db에 입력된 날짜코드
 */
export const getConvertedDate = (code?: string) => {
  if (!code) return null;

  if (code.includes("/")) {
    // 현재 날짜를 기준으로 작업
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0 = January
    const currentDate = now.getDate();

    // 구분자(/)로 값을 분리
    const [yearPart, monthPart, datePart] = code.split("/");

    // 년도 계산
    const year =
      yearPart === "0" ? currentYear : currentYear + parseInt(yearPart);

    // 월 계산
    let month;
    if (monthPart === "0") {
      month = currentMonth;
    } else if (monthPart.toLowerCase() === "f") {
      month = 0; // 1월
    } else if (monthPart.toLowerCase() === "l") {
      month = 11; // 12월
    } else {
      month = currentMonth + parseInt(monthPart);
    }

    // 일 계산
    let date;
    if (datePart === "0") {
      date = currentDate;
    } else if (datePart.toLowerCase() === "f") {
      date = 1; // 첫째 날
    } else if (datePart.toLowerCase() === "l") {
      return dayjs(new Date(year, month + 1, 0)).format("YYYYMMDD");
    } else {
      date = currentDate + parseInt(datePart);
    }

    // 말일 보정
    const result = new Date(year, month, date);
    if (result.getDate() !== date) {
      return dayjs(new Date(year, month + 1, 0)).format("YYYYMMDD");
    }

    return dayjs(result).format("YYYYMMDD");
  }

  // '/'가 없는 경우: 그대로 반환(예: 20250103)
  return code;
};

/**
 * PopupSettings.ts 파일에서 isMultiple 속성 조회하는 메서드
 * @param code 팝업 코드
 */
export const checkIsMultiple = (code: string) => {
  const popupSetting = PopupSettings[code];
  const activeMenu = globalMenu.getState().activeMenuInfo.cd_menu;

  if (!popupSetting) return false;

  const multipleMenus = popupSetting.isMultiple;
  if (multipleMenus) {
    return multipleMenus.includes(activeMenu);
  }
  return false;
};

// 날짜 형식 체크: 'yyyyMMdd' 또는 'yyyy-MM-dd'
export const isDateValue = (val: any): boolean => {
  return (
    typeof val === "string" &&
    (/^\d{8}$/.test(val) || /^\d{4}-\d{2}-\d{2}$/.test(val))
  );
};

// 숫자형 체크: 숫자이면서 boolean, null, ''은 제외
export const isNumeric = (val: any): boolean => {
  return (
    typeof val === "number" ||
    (!isNaN(val) && val !== "" && val !== null && typeof val !== "boolean")
  );
};

// 날짜 파싱 함수
export const parseDate = (val: string): Date | null => {
  if (!val) return null;

  // YYYYMMDD → YYYY-MM-DD로 포맷 변경
  if (/^\d{8}$/.test(val)) {
    val = `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(
      6,
      8
    )}`;
  }

  return new Date(val);
};

/**
 * cd_value가 ''에 감싸져있으면 userInfo에 있는 데이터로 치환(예 - 'cd_firm' → '1000')
 * @param value
 */
export const convertLoginData = (value: string) => {
  let result;
  if (/^'.+'$/.test(value)) {
    const key = value.slice(1, -1);
    result = global.getState().userInfo[key];
  }
  return result ? result : value;
};

export const getCurrentTime = () => {
  const now = new Date();
  const formattedTime =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0") +
    " " +
    String(now.getHours()).padStart(2, "0") +
    ":" +
    String(now.getMinutes()).padStart(2, "0") +
    ":" +
    String(now.getSeconds()).padStart(2, "0") +
    "." +
    String(now.getMilliseconds()).padStart(3, "0");

  return formattedTime;
};

export const applySlip = async (params: {
  cd_column: string;
  cd_module?: string;
  no_line: number;
  cd_prefix: string;
  dt: string;
  cd_menu?: string;
  girdrefs?: any[];
  inserts?: any[];
  formrefs?: any[];
}) => {
  try {
    const noSlip = await getNoSlip(
      params.cd_module || globalMenu.getState().activeMenuInfo.cd_module || "",
      params.no_line,
      params.cd_prefix,
      params.dt,
      globalMenu.getState().activeMenuInfo.cd_menu
    );
    if (typeof noSlip === "string" && noSlip != "") {
      params.girdrefs?.forEach((grid) => {
        const filterd: any[] = [];
        grid.current?.forEachNode((node: any) => {
          if (
            node.data[params.cd_column] == "" ||
            node.data[params.cd_column] == null ||
            node.data[params.cd_column] == undefined
          ) {
            filterd.push(node);
          }
        });
        filterd.forEach((row) => {
          row.setDataValue(params.cd_column, noSlip, "noEvent");
        });
      });
      params.formrefs?.forEach((form) => {
        form.current?.setDataValue(params.cd_column, noSlip, "noEvent");
      });
    } else {
      throw new Error();
    }
    return noSlip;
  } catch (error) {
    showDialog("error", "전표채번에 실패했습니다.");
  }
};

//  공통 키 정규화: 문자열화 + NBSP 제거 + trim
export const normalizeKey = (v: any) =>
  String(v ?? "")
    .replace(/\u00A0/g, " ")
    .trim();

// 대문자 정규화 키: trim/NBSP 정리 후 대문자로 통일
export const normalizeUpperKey = (v: any) => normalizeKey(v).toUpperCase();

// Y/N 플래그 공통 판정
export const isYnY = (v: any) => normalizeUpperKey(v) === "Y";

// 문자열/숫자 입력을 안전한 숫자로 변환
export const toNum = (v: any) => {
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;
  const s = String(v ?? "")
    .replaceAll(",", "")
    .replace(/\u2212/g, "-")
    .trim();
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};

// 수량/금액 부동소수점 오차 제거 (기본 소수점 4자리 반올림)
// 예) 132.26 - 109 - 23.26 => -1.0658e-14 => 0
export const roundNum = (v: any, dec: number = 4) => {
  const n = toNum(v);
  const f = Math.pow(10, dec);
  return Math.round(n * f) / f + 0; // -0 방지
};

export type FormatNumberOptions = {
  fractionDigits?: number;
  abs?: boolean;
};

export const formatNumber = (
  value: number,
  options: FormatNumberOptions = {}
) => {
  const { fractionDigits = 1, abs = false } = options;
  const formatValue = abs ? Math.abs(value) : value;

  return formatValue.toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

/**
 * 엑셀 방식 숫자 포맷 — # 은 값이 있을 때만 표시, 0 은 값이 없으면 0으로 채움
 * 예) "#,####.####" : 12345.678 -> "12,345.678" / 12345 -> "12,345."
 *     "#,####.##00" : 12345.6   -> "12,345.600" / 1234  -> "1,234.00"
 */
export const fnFormatNumberByPattern = (
  value: number,
  pattern: string
): string => {
  const dotIndex = pattern.indexOf(".");
  const intPattern = (
    dotIndex >= 0 ? pattern.slice(0, dotIndex) : pattern
  ).replace(/,/g, "");
  const decPattern = dotIndex >= 0 ? pattern.slice(dotIndex + 1) : "";
  const useGrouping = pattern.includes(",");

  const sign = value < 0 ? "-" : "";
  const abs = Math.abs(value);

  // 소수 자릿수만큼 반올림한 뒤 정수부/소수부 분리
  const fixed = abs.toFixed(decPattern.length);
  const [intDigits, decRaw = ""] = fixed.split(".");
  const realDec = decRaw.replace(/0+$/, ""); // 실제 값이 있는 소수 자릿수만 남김

  // 소수부: 앞에서부터 실제 값을 채우고, 남은 자리는 0이면 '0', #이면 생략
  let decStr = "";
  for (let i = 0; i < decPattern.length; i++) {
    if (i < realDec.length) decStr += realDec[i];
    else if (decPattern[i] === "0") decStr += "0";
  }

  // 정수부: 패턴의 0 개수만큼 최소 자릿수 확보, #만 있으면 값 0은 생략
  const minIntDigits = (intPattern.match(/0/g) || []).length;
  let intStr = intDigits === "0" && minIntDigits === 0 ? "" : intDigits;
  intStr = intStr.padStart(minIntDigits, "0");
  if (useGrouping && intStr) {
    intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const result = dotIndex >= 0 ? `${intStr}.${decStr}` : intStr;
  return result === "" || result === "." ? "" : `${sign}${result}`;
};

//  raw 결과에서 '진짜 rows'만 꺼내기 ([ [..] ], {rows:[..]}, [..] 모두 흡수)
export const ensureRows = (raw: any): any[] => {
  if (Array.isArray(raw)) {
    if (raw.length === 1 && Array.isArray(raw[0])) return raw[0]; // [[...]]
    return raw; // [...]
  }
  if (raw && Array.isArray(raw.rows)) return raw.rows; // {rows:[...]}
  return [];
};

export type ToKeyMapOpts<T = any> = {
  key: string | ((row: T) => any); // 기준 키 (예: "cd_so")
  // 키 대체 후보 (선택): 대소문자/별칭이 있을 때 명시 (예: ["CD_SO"])
  candidates?: string[];
  // 값 가공(선택): map 값으로 row 전체 대신 일부만 쓰고 싶을 때
  pick?: (row: T) => any;
  // 키 정규화 커스텀(선택)
  normalize?: (v: any) => string;
};

//  만능: 리스트/중첩배열/{rows:[]} 어떤 형태든 → { [키]: 값 } 으로
export function toKeyMap<T = any>(
  raw: any,
  opts: ToKeyMapOpts<T>
): Record<string, any> {
  const rows = ensureRows(raw);
  const copyRows = rows.map((row) => ({ ...row }));
  const norm = opts.normalize ?? normalizeKey;
  const out: Record<string, any> = Object.create(null);

  for (const r of copyRows) {
    delete r.dc_rmk;
    delete r.yn_use;
    delete r.tm_reg;
    delete r.cd_user_reg;
    delete r.tm_amd;
    delete r.cd_user_amd;

    let keyVal: any;

    if (typeof opts.key === "function") {
      keyVal = (opts.key as any)(r);
    } else {
      // 1) 정확한 키
      keyVal = (r as any)?.[opts.key];
      // 2) 후보 키들
      if (keyVal == null && opts.candidates?.length) {
        for (const k of opts.candidates) {
          if ((r as any)?.[k] != null) {
            keyVal = (r as any)[k];
            break;
          }
        }
      }
      // 3) 자동 변형(대문자/소문자/스네이크/카멜)
      if (keyVal == null) {
        const up = opts.key.toUpperCase();
        const low = opts.key.toLowerCase();
        const camel = opts.key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
        const snake = opts.key.replace(/[A-Z]/g, (c) => "_" + c.toLowerCase());
        for (const k of [up, low, camel, snake]) {
          if ((r as any)?.[k] != null) {
            keyVal = (r as any)[k];
            break;
          }
        }
      }
    }

    const k = norm(keyVal);
    if (!k) continue;

    out[k] = opts.pick ? opts.pick(r) : r; // 값 가공이 있으면 가공, 없으면 행 전체
  }
  return out;
}

//  이미 객체(Record)로 들어온 map의 키들도 정규화(안전용)
export function normalizeMapKeys(
  map: Record<string, any>,
  normalize = normalizeKey
) {
  const out: Record<string, any> = Object.create(null);
  for (const [k, v] of Object.entries(map ?? {})) out[normalize(k)] = v;
  return out;
}

// tp_format 문자열을 date-fns 포맷으로 정규화
const normalizeDateFnsFormat = (fmt?: string): string => {
  if (!fmt || fmt.trim() === "") return "yyyyMMdd";
  const raw = fmt.trim();

  const shortcuts: Record<string, string> = {
    yyyymmdd: "yyyyMMdd",
    "yyyy-mm-dd": "yyyy-MM-dd",
    "yyyy/mm/dd": "yyyy/MM/dd",
    "mm-dd-yy": "MM-dd-yy",
    "dd-mm-yy": "dd-MM-yy",
    "mm/dd/yy": "MM/dd/yy",
    "dd/mm/yy": "dd/MM/yy",
    "mm-dd-yyyy": "MM-dd-yyyy",
    "dd-mm-yyyy": "dd-MM-yyyy",
    "mm/dd/yyyy": "MM/dd/yyyy",
    "dd/mm/yyyy": "dd/MM/yyyy",
  };

  const key = raw.toLowerCase();
  if (shortcuts[key]) return shortcuts[key];

  // 일반 규칙 변환
  return raw
    .replace(/mm/g, "MM")
    .replace(/m/g, "M")
    .replace(/y/gi, "y")
    .replace(/dd/gi, "dd");
};

// 설정된 날짜형식에 맞는지 체크
export const isDateByFormat = (value: string, fmt?: string): boolean => {
  if (typeof value !== "string" || value.trim() === "") return false;

  const pattern = normalizeDateFnsFormat(fmt);
  const parsed = dfns.parse(value, pattern, new Date());

  // parse → isValid → format(parsed) 결과가 원본과 같아야만 true
  return dfns.isValid(parsed) && dfns.format(parsed, pattern) === value;
};

// 모든 날짜 형식을  yyyyMMdd 변환
export const parseToyyyyMMdd = (value: string, fmt?: string): string | null => {
  if (typeof value !== "string" || value.trim() === "") return null;

  const pattern = normalizeDateFnsFormat(fmt);
  const parsed = dfns.parse(value, pattern, new Date());

  if (!dfns.isValid(parsed) || dfns.format(parsed, pattern) !== value) {
    return null; // 유효하지 않음
  }

  // 항상 yyyyMMdd로 반환
  return dfns.format(parsed, "yyyyMMdd");
};

// ───────────────────────────────────────────────────────────────
// SnSheet 전용: 엑셀 붙여넣기로 들어온 날짜 문자열을 관대하게 yyyyMMdd로 변환
// (parseToyyyyMMdd 는 tp_format 엄격 일치만 허용하므로 그대로 두고 별도 함수로 분리)
// ───────────────────────────────────────────────────────────────

// 보조 포맷 목록 (tp_format 불일치 시 순서대로 시도)
const SNSHEET_FALLBACK_DATE_FORMATS = [
  "yyyyMMdd",
  "yyyy-MM-dd",
  "yyyy/MM/dd",
  "yyyy.MM.dd",
  "yyyy-M-d",
  "yyyy/M/d",
  "yyyy.M.d",
  "yyyy-MM-dd'T'HH:mm:ss",
  "MM/dd/yyyy",
  "M/d/yyyy",
  "MM-dd-yyyy",
  "dd.MM.yyyy",
  // 연도 2자리 (엑셀 "yy-mm-dd" 계열): 연도가 앞에 오는 형식만 허용
  "yy-MM-dd",
  "yy/MM/dd",
  "yy.MM.dd",
  "yy-M-d",
  "yy/M/d",
  "yy.M.d",
  "yyMMdd",
];

const isSaneYear = (d: Date) => {
  const y = d.getFullYear();
  return y >= 1900 && y <= 2100;
};

// 엑셀 날짜 일련번호(1900 기준) → Date
const excelSerialToDate = (serial: number): Date | null => {
  if (!Number.isFinite(serial) || serial < 1 || serial > 2958465) return null;
  // 1899-12-30 기준 (엑셀 1900 윤년 버그 보정 포함)
  const ms = Math.round((serial - 25569) * 86400 * 1000);
  const d = new Date(ms);
  // UTC 기준 날짜를 로컬 Date로 재구성
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

/**
 * SnSheet 붙여넣기용 날짜 정규화 (handlePasteData 에서 날짜 컬럼 값을 즉시 yyyyMMdd 로 변환).
 * 한글 장형("2026년 10월 1일 목요일") → tp_format 및 보조 포맷 순회 → 엑셀 일련번호 순으로 관대하게 해석
 * 실패 시 null
 */
export const parseToyyyyMMddSnSheet = (
  value: string | number | Date,
  fmt?: string
): string | null => {
  if (value instanceof Date) {
    return dfns.isValid(value) && isSaneYear(value)
      ? dfns.format(value, "yyyyMMdd")
      : null;
  }
  if (typeof value === "number") {
    const d = excelSerialToDate(value);
    return d && isSaneYear(d) ? dfns.format(d, "yyyyMMdd") : null;
  }
  if (typeof value !== "string" || value.trim() === "") return null;

  const raw = value.trim();
  const pattern = normalizeDateFnsFormat(fmt);

  // 1) 한글 장형: "2026년 10월 1일", "2026년 10월 1일 목요일", "2026년 10월 1일 (목)"
  const ko = raw.match(/^(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
  if (ko) {
    const d = new Date(Number(ko[1]), Number(ko[2]) - 1, Number(ko[3]));
    if (
      d.getFullYear() === Number(ko[1]) &&
      d.getMonth() === Number(ko[2]) - 1 &&
      d.getDate() === Number(ko[3])
    ) {
      return dfns.format(d, "yyyyMMdd");
    }
    return null;
  }

  // 2) 뒤에 붙은 시간/요일/괄호 제거 후 포맷 순회 (컬럼 tp_format 을 맨 앞에 두고 한 번만 돈다)
  //    "2026-10-01 오후 2:30:00", "2026-10-01 14:30", "2026-10-01 (목)", "26-10-01", "2026.10.1" ...
  const stripped = raw
    // 시간 꼬리: "14:30", "14:30:00", "오후 2:30:00", "2:30 PM", "T14:30:00"
    .replace(
      /(?:\s|T)*(?:오전|오후|AM|PM)?\s*\d{1,2}:\d{2}(?::\d{2})?(?:\.\d+)?\s*(?:오전|오후|AM|PM)?\s*$/i,
      ""
    )
    // 요일 꼬리: "목요일", "(목)", "(Thu)"
    .replace(/\s*\(?[월화수목금토일](?:요일)?\)?\s*$/, "")
    .replace(/\s*\((Mon|Tue|Wed|Thu|Fri|Sat|Sun)[a-z]*\)\s*$/i, "")
    .trim();
  // 컬럼 tp_format 의 구분자만 바꾼 형태를 보조 포맷보다 먼저 시도한다
  // (tp_format "mm-dd-yy" 인데 엑셀이 "12/12/25" 로 주면 MM/dd/yy 로 읽어야 한다)
  const sepVariants = ["-", "/", "."].map((sep) =>
    pattern.replace(/[-/.]/g, sep)
  );
  for (const f of [pattern, ...sepVariants, ...SNSHEET_FALLBACK_DATE_FORMATS]) {
    const d = dfns.parse(stripped, f, new Date());
    if (dfns.isValid(d) && isSaneYear(d)) {
      return dfns.format(d, "yyyyMMdd");
    }
  }

  // 3) 엑셀 일련번호 (서식이 '일반'으로 풀린 경우): 5자리 숫자만 허용
  if (/^\d{5}$/.test(stripped)) {
    const d = excelSerialToDate(Number(stripped));
    if (d && isSaneYear(d)) return dfns.format(d, "yyyyMMdd");
  }

  return null;
};

export const CalAm = async (apiH: any, apiL: any, colId: string) => {
  try {
    const targets = [
      "qt",
      "fg_vat",
      "rt_exch",
      "um_supply",
      "um",
      "um_k",
      "am",
      "am_k",
      "am_vat",
      "qt_unit_po",
      "qt_po",
      "um_po",
    ];

    if (!targets.includes(colId.toLowerCase())) return;
    let rowDataL: any;
    if (typeof apiL.current?.getRowNode === "function") {
      rowDataL = apiL.current.focusedRowNode().data;
    }
    if (typeof apiL.current?.getFormdata === "function") {
      rowDataL = apiL.current.getFormdata();
    }
    let rowData = rowDataL;

    let rowDataH: any;
    let fg_vat = rowDataL.fg_vat || null;
    if (apiH) {
      if (typeof apiH.current?.getRowNode === "function") {
        rowDataH = apiH.current.focusedRowNode().data;
      }
      if (typeof apiH.current?.getFormdata === "function") {
        rowDataH = apiH.current.getFormdata();
      }
      // rowDataL에 rt_exch가 없으면 rowDataH에서 찾아서 넣어줌
      if (!rowData.rt_exch && rowDataH.rt_exch) {
        rowData.rt_exch = rowDataH.rt_exch;
      }
      if (!fg_vat) fg_vat = rowDataH.fg_vat;
    }

    const params = {
      fg_vat: fg_vat,
      rowData: rowData,
      colId: colId,
    };
    const response = await axios.post("/snotes/CalAm", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });
    const data = response.data;
    if (apiL) {
      const rowNodeL = apiL.current.getRowNode(rowDataL.KeyField);
      if (rowNodeL) {
        const allColsL =
          apiL.current.getAllGridColumns()?.map((col: any) => col.getColId()) ||
          [];
        const setIfExists = (col: string, value: any) => {
          if (allColsL.includes(col) && value !== undefined) {
            rowNodeL.setDataValue(col, value, "noEvent");
          }
        };

        setIfExists("am", data.am);
        setIfExists("am_k", data.am_k);
        setIfExists("am_vat", data.am_vat);
        setIfExists("am_supply", data.am_supply);
        setIfExists("um_k", data.um_k);
        setIfExists("um_supply", data.um_supply);
        setIfExists("qt", data.qt);
        setIfExists("um", data.um);
        setIfExists("qt_po", data.qt_po);
        setIfExists("um_po", data.um_po);

        await apiL.current.calculateTotals();
      }
    }
    if (apiH) {
      const footerData = apiL.current.getFooterData();
      if (typeof apiH.current?.getRowNode === "function") {
        const rowNodeH = apiH.current.getRowNode(rowDataH.KeyField);
        if (rowNodeH) {
          const allColsH =
            apiH.current
              .getAllGridColumns()
              ?.map((col: any) => col.getColId()) || [];
          const setIfExists = (col: string, value: any) => {
            if (allColsH.includes(col) && value !== undefined)
              rowNodeH.setDataValue(col, value, "noEvent");
          };

          setIfExists("am", footerData.am);
          setIfExists("am_k", footerData.am_k);
          setIfExists("am_vat", footerData.am_vat);
          setIfExists("am_supply", footerData.am_supply);
          setIfExists("um_k", footerData.um_k);
          setIfExists("um_supply", footerData.um_supply);

          await apiH.current.calculateTotals();
        }
      }
      if (typeof apiH.current?.getFormdata === "function") {
        const formDataH = apiH.current.getFormdata();
        const setIfExists = (col: string, value: any) => {
          if (
            Object.prototype.hasOwnProperty.call(formDataH, col) &&
            value !== undefined
          )
            apiH.current.setDataValue(col, value, "noEvent");
        };

        setIfExists("am", footerData.am);
        setIfExists("am_k", footerData.am_k);
        setIfExists("am_vat", footerData.am_vat);
        setIfExists("am_supply", footerData.am_supply);
        setIfExists("um_k", footerData.um_k);
        setIfExists("um_supply", footerData.um_supply);
      }
    }
    return data;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

export const CalAmBulk = async (apiH: any, apiL: any, colId: string) => {
  try {
    const targets = ["fg_vat", "rt_exch"];

    if (!targets.includes(colId.toLowerCase())) return;
    const rowsDataL: any[] = apiL.current.getFilteredData();

    let rowDataH: any;
    if (typeof apiH.current?.getRowNode === "function") {
      rowDataH = apiH.current.focusedRowNode().data;
    }
    if (typeof apiH.current?.getFormdata === "function") {
      rowDataH = apiH.current.getFormdata();
    }
    console.log(rowDataH);
    rowsDataL.map((rowData: any) => {
      if (rowDataH.rt_exch !== null && rowDataH.rt_exch !== undefined) {
        rowData.rt_exch = rowDataH.rt_exch;
      }
      if (rowDataH.fg_vat && (!rowData.fg_vat || rowData.fg_vat === "")) {
        rowData.fg_vat = rowDataH.fg_vat;
      }
    });
    const params = {
      rowsData: rowsDataL,
    };
    const response = await axios.post("/snotes/CalAmBulk", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });
    const data = response.data;
    console.log(data);
    if (apiL) {
      const allColsL =
        apiL.current.getAllGridColumns()?.map((col: any) => col.getColId()) ||
        [];

      apiL.current.forEachFilteredNode((node: RowNode) => {
        const setIfExists = (col: string, value: any) => {
          if (allColsL.includes(col) && value !== undefined)
            node.setDataValue(col, value, "noEvent");
        };
        const keyData = data.filter(
          (d: any) => d.KeyField === node.data.KeyField
        );
        if (keyData.length > 0) {
          setIfExists("am", keyData[0].am);
          setIfExists("am_k", keyData[0].am_k);
          setIfExists("am_vat", keyData[0].am_vat);
          setIfExists("am_supply", keyData[0].am_supply);
          setIfExists("um_k", keyData[0].um_k);
          setIfExists("um_supply", keyData[0].um_supply);
        }
      });
      await apiL.current.calculateTotals();
    }
    if (apiH) {
      const footerData = apiL.current.getFooterData();
      if (typeof apiH.current?.getRowNode === "function") {
        const rowNodeH = apiH.current.getRowNode(rowDataH.KeyField);
        if (rowNodeH) {
          const allColsH =
            apiH.current
              .getAllGridColumns()
              ?.map((col: any) => col.getColId()) || [];
          const setIfExists = (col: string, value: any) => {
            if (allColsH.includes(col) && value !== undefined)
              rowNodeH.setDataValue(col, value, "noEvent");
          };
          setIfExists("am", footerData.am);
          setIfExists("am_k", footerData.am_k);
          setIfExists("am_vat", footerData.am_vat);
          setIfExists("am_supply", footerData.am_supply);
          setIfExists("um_k", footerData.um_k);
          setIfExists("um_supply", footerData.um_supply);

          await apiH.current.calculateTotals();
        }
      }
      if (typeof apiH.current?.getFormdata === "function") {
        const formDataH = apiH.current.getFormdata();
        const setIfExists = (col: string, value: any) => {
          if (
            Object.prototype.hasOwnProperty.call(formDataH, col) &&
            value !== undefined
          )
            apiH.current.setDataValue(col, value, "noEvent");
        };
        setIfExists("am", footerData.am);
        setIfExists("am_k", footerData.am_k);
        setIfExists("am_vat", footerData.am_vat);
        setIfExists("am_supply", footerData.am_supply);
        setIfExists("um_k", footerData.um_k);
        setIfExists("um_supply", footerData.um_supply);
      }
    }
    return data;
  } catch (error) {
    console.error("API 호출 실패1", error);
    throw error;
  }
};

export const CalAmInit = async (rowData: any) => {
  try {
    const params = {
      fg_vat: rowData.fg_vat,
      rowData: rowData,
      colId: "qt",
    };
    const response = await axios.post("/snotes/CalAm", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });
    return response.data;
  } catch (error) {
    console.error("CalAmInit API 호출 실패", error);
    throw error;
  }
};

export const CalAmBulkInit = async (rowDataH: any, rowsDataL: any[]) => {
  try {
    const rows = [...rowsDataL];
    rows.forEach((rowData: any) => {
      if (rowDataH.rt_exch !== null && rowDataH.rt_exch !== undefined) {
        rowData.rt_exch = rowDataH.rt_exch;
      }

      if (rowDataH.fg_vat && (!rowData.fg_vat || rowData.fg_vat === "")) {
        rowData.fg_vat = rowDataH.fg_vat;
      }
    });

    const params = {
      rowsData: rows,
    };
    const response = await axios.post("/snotes/CalAmBulk", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    return response.data;
  } catch (error) {
    console.error("CalAmInitBulk API 호출 실패", error);
    throw error;
  }
};

export const setConfigToColumns = (columns: any[], cdCtrl: String) => {
  const config = global.getState().config;
  if (!config) return columns;
  switch (cdCtrl) {
    case "MAS0002": // Project 사용유무
      const masVal = config?.MAS0002?.dc_ctrl ?? "";
      if (masVal === "Y") {
        return columns.map((col: any) =>
          ["cd_pjt", "no_wbs", "no_cbs"].includes(col.cd_column)
            ? { ...col, fg_visible: "Y" }
            : col
        );
      } else if (masVal === "N") {
        return columns.map((col: any) =>
          ["cd_pjt", "no_wbs", "no_cbs"].includes(col.cd_column)
            ? { ...col, fg_visible: "N" }
            : col
        );
      }
      break;
    case "PUR0105": // 발주등록 시 프로젝트 필수여부
      const purVal = config?.PUR0105?.dc_ctrl ?? "";
      if (purVal === "Y") {
        return columns.map((col: any) =>
          ["cd_pjt"].includes(col.cd_column)
            ? { ...col, yn_required: "Y" }
            : col
        );
      } else if (purVal === "N") {
        return columns.map((col: any) =>
          ["cd_pjt"].includes(col.cd_column)
            ? { ...col, yn_required: "N" }
            : col
        );
      }
      break;
    case "MTL0002": // LOT 사용유무
      const mtlVal = config?.MTL0002?.dc_ctrl ?? "";
      if (mtlVal === "Y") {
        return columns.map((col: any) =>
          ["no_lot"].includes(col.cd_column) ? { ...col, fg_visible: "Y" } : col
        );
      } else if (mtlVal === "N") {
        return columns.map((col: any) =>
          ["no_lot"].includes(col.cd_column) ? { ...col, fg_visible: "N" } : col
        );
      }
      break;
    case "SAL0010": // 납품처관리
      const sal0010Val = config?.SAL0010?.dc_ctrl ?? "";
      if (sal0010Val === "Y") {
        return columns.map((col: any) =>
          ["cd_cust_dlv"].includes(col.cd_column)
            ? { ...col, fg_visible: "Y" }
            : col
        );
      } else if (sal0010Val === "N") {
        return columns.map((col: any) =>
          ["cd_cust_dlv"].includes(col.cd_column)
            ? { ...col, fg_visible: "N" }
            : col
        );
      }
      break;
    case "MTL0017": // 로케이션 관리유무
      const dcmtl0017Val = config?.MTL0017.dc_ctrl ?? "";
      if (dcmtl0017Val === "Y") {
        return columns.map((col: any) =>
          ["cd_loc"].includes(col.cd_column) ? { ...col, fg_visible: "Y" } : col
        );
      } else if (dcmtl0017Val === "N") {
        return columns.map((col: any) =>
          ["cd_loc"].includes(col.cd_column) ? { ...col, fg_visible: "N" } : col
        );
      }
      break;
  }
  return columns;
};

/**
 * 기준일자, 날짜차이 숫자를 이용하여 원하는 근무일 구하는 함수
 * @param dt 기준일자 ex) '20260120'
 * @param dateDiff 날짜차이 ex) 1, -3, -1 등
 */
export const getPlanDt = async (dt: string, dateDiff: number) => {
  const payload = {
    id: "getPlanDt",
    params: {
      cd_firm: global.getState().userInfo.cd_firm,
      dt: dt,
      dateDiff: dateDiff,
    },
  };
  const data = await fnGetTableById(payload);
  return data[0].dt;
};

export const setUmByFgUm = async (
  apiH: any,
  apiL: any,
  dt: string,
  tp_um?: any,
  rowNodesL?: RowNode[]
) => {
  const cd_module = globalMenu.getState().activeMenuInfo.cd_module;

  let rowDataH: any;
  if (typeof apiH.current?.getRowNode === "function") {
    rowDataH = apiH.current.focusedRowNode().data;
  }
  if (typeof apiH.current?.getFormdata === "function") {
    rowDataH = apiH.current.getFormdata();
  }
  // 2026-10-16 받은 단가유형이 있을 때만 상단에 넣는다. || 였어서 비어 있어도(undefined) 넣어 상단 단가유형이 지워졌다
  // (하단 품목을 직접 입력하거나 챗봇이 복사할 때 저장이 "tp_um 값 없음" 으로 막혔다)
  if (tp_um && tp_um !== "") rowDataH.tp_um = tp_um;

  const rowsDataL: any[] = apiL.current.getFilteredData();
  const rt_exch = getValue("rt_exch", rowDataH, rowsDataL);
  const fg_vat = getValue("fg_vat", rowDataH, rowsDataL);
  const tp_um_val = getValue("tp_um", rowDataH, rowsDataL);

  rowsDataL.forEach((rowData: any) => {
    if (rt_exch !== undefined && (!rowData.rt_exch || rowData.rt_exch === ""))
      rowData.rt_exch = rt_exch;
    if (fg_vat !== undefined && (!rowData.fg_vat || rowData.fg_vat === ""))
      rowData.fg_vat = fg_vat;
    if (tp_um_val !== undefined && (!rowData.tp_um || rowData.tp_um === ""))
      rowData.tp_um = tp_um_val;
  });

  const config = global.getState().config;
  let fgUm = "1";
  if (cd_module === "SAL") {
    fgUm = config.SAL0001.dc_ctrl;
  } else {
    fgUm = config.PUR0001.dc_ctrl;
  }

  const params = {
    cdModule: cd_module,
    fgUm: fgUm,
    dt: dt,
    rowDataH: rowDataH,
    rowsDataL: rowsDataL,
  };
  const makeKey = (d: any) =>
    `${d.cd_item || ""}|${d.cd_cust || ""}|${d.cd_exch || ""}`;

  const response = await axios.post("/snotes/setUm", params, {
    headers: {
      "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
    },
  });

  const data = response.data;

  const dataMap = new Map<string, any>(data.map((d: any) => [makeKey(d), d]));

  if (apiL) {
    const allColsL =
      apiL.current.getAllGridColumns()?.map((col: any) => col.getColId()) || [];

    const setIfExists = (node: RowNode, col: string, value: any) => {
      if (allColsL.includes(col)) node.setDataValue(col, value, "noEvent");
    };

    const processNode = (node: RowNode) => {
      const keyData = dataMap.get(makeKey(node.data));
      if (!keyData) return;

      setIfExists(node, "um", keyData.um);
      setIfExists(node, "am", keyData.am);
      setIfExists(node, "am_k", keyData.am_k);
      setIfExists(node, "am_vat", keyData.am_vat);
      setIfExists(node, "am_supply", keyData.am_supply);
      setIfExists(node, "um_k", keyData.um_k);
      setIfExists(node, "um_supply", keyData.um_supply);
    };

    if (rowNodesL) {
      rowNodesL.forEach(processNode);
    } else {
      apiL.current.forEachFilteredNode(processNode);
    }

    await apiL.current.calculateTotals();
  }

  if (apiH) {
    const footerData = apiL.current.getFooterData();

    if (typeof apiH.current?.getRowNode === "function") {
      const rowNodeH = apiH.current.getRowNode(rowDataH.KeyField);

      if (rowNodeH) {
        const allColsH =
          apiH.current.getAllGridColumns()?.map((col: any) => col.getColId()) ||
          [];

        const setIfExists = (col: string, value: any) => {
          if (allColsH.includes(col) && value)
            rowNodeH.setDataValue(col, value, "noEvent");
        };

        setIfExists("am", footerData.am);
        setIfExists("am_k", footerData.am_k);
        setIfExists("am_vat", footerData.am_vat);
        setIfExists("am_supply", footerData.am_supply);
        setIfExists("um_k", footerData.um_k);
        setIfExists("um_supply", footerData.um_supply);

        await apiH.current.calculateTotals();
      }
    }

    if (typeof apiH.current?.getFormdata === "function") {
      const formDataH = apiH.current.getFormdata();

      const setIfExists = (col: string, value: any) => {
        if (Object.prototype.hasOwnProperty.call(formDataH, col) && value)
          apiH.current.setDataValue(col, value, "noEvent");
      };

      setIfExists("am", footerData.am);
      setIfExists("am_k", footerData.am_k);
      setIfExists("am_vat", footerData.am_vat);
      setIfExists("am_supply", footerData.am_supply);
      setIfExists("um_k", footerData.um_k);
      setIfExists("um_supply", footerData.um_supply);
    }
  }

  return data;
  // const response = await axios.post("/snotes/setUm", params, {
  //   headers: {
  //     "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
  //   },
  // });
  // const data = response.data;
  // if (apiL) {
  //   const allColsL =
  //     apiL.current.getAllGridColumns()?.map((col: any) => col.getColId()) || [];
  //   if (rowNodesL) {
  //     rowNodesL.forEach((node: RowNode) => {
  //       const setIfExists = (col: string, value: any) => {
  //         if (allColsL.includes(col)) node.setDataValue(col, value, "noEvent");
  //       };
  //       const keyData = data.filter(
  //         (d: any) => d.KeyField === node.data.KeyField
  //       );
  //       if (keyData.length > 0) {
  //         setIfExists("um", keyData[0].um);
  //         setIfExists("am", keyData[0].am);
  //         setIfExists("am_k", keyData[0].am_k);
  //         setIfExists("am_vat", keyData[0].am_vat);
  //         setIfExists("am_supply", keyData[0].am_supply);
  //         setIfExists("um_k", keyData[0].um_k);
  //         setIfExists("um_supply", keyData[0].um_supply);
  //       }
  //     });
  //   } else {
  //     apiL.current.forEachFilteredNode((node: RowNode) => {
  //       const setIfExists = (col: string, value: any) => {
  //         if (allColsL.includes(col)) node.setDataValue(col, value, "noEvent");
  //       };
  //       const keyData = data.filter(
  //         (d: any) => d.KeyField === node.data.KeyField
  //       );
  //       if (keyData.length > 0) {
  //         setIfExists("um", keyData[0].um);
  //         setIfExists("am", keyData[0].am);
  //         setIfExists("am_k", keyData[0].am_k);
  //         setIfExists("am_vat", keyData[0].am_vat);
  //         setIfExists("am_supply", keyData[0].am_supply);
  //         setIfExists("um_k", keyData[0].um_k);
  //         setIfExists("um_supply", keyData[0].um_supply);
  //       }
  //     });
  //   }

  //   await apiL.current.calculateTotals();
  // }
  // if (apiH) {
  //   const footerData = apiL.current.getFooterData();
  //   if (typeof apiH.current?.getRowNode === "function") {
  //     const rowNodeH = apiH.current.getRowNode(rowDataH.KeyField);
  //     if (rowNodeH) {
  //       const allColsH =
  //         apiH.current.getAllGridColumns()?.map((col: any) => col.getColId()) ||
  //         [];
  //       const setIfExists = (col: string, value: any) => {
  //         if (allColsH.includes(col) && value)
  //           rowNodeH.setDataValue(col, value, "noEvent");
  //       };
  //       setIfExists("am", footerData.am);
  //       setIfExists("am_k", footerData.am_k);
  //       setIfExists("am_vat", footerData.am_vat);
  //       setIfExists("am_supply", footerData.am_supply);
  //       setIfExists("um_k", footerData.um_k);
  //       setIfExists("um_supply", footerData.um_supply);

  //       await apiH.current.calculateTotals();
  //     }
  //   }
  //   if (typeof apiH.current?.getFormdata === "function") {
  //     const formDataH = apiH.current.getFormdata();
  //     const setIfExists = (col: string, value: any) => {
  //       if (Object.prototype.hasOwnProperty.call(formDataH, col) && value)
  //         apiH.current.setDataValue(col, value, "noEvent");
  //     };

  //     setIfExists("am", footerData.am);
  //     setIfExists("am_k", footerData.am_k);
  //     setIfExists("am_vat", footerData.am_vat);
  //     setIfExists("am_supply", footerData.am_supply);
  //     setIfExists("um_k", footerData.um_k);
  //     setIfExists("um_supply", footerData.um_supply);
  //   }
  // }
  // return data;
};

const getValue = (key: string, rowDataH: any, rowsDataL: any[]) => {
  if (rowDataH?.[key] !== undefined && rowDataH?.[key] !== null) {
    return rowDataH[key];
  }
  const found = rowsDataL.find(
    (row) => row?.[key] !== undefined && row?.[key] !== null
  );

  return found?.[key];
};

/**
 * iotype 조회
 * @param cd_module
 * @param fg_slip
 * @param tp_slip
 * @param cd_io
 */
export const fnGetIotype = async (
  cd_module: string,
  fg_slip: string,
  tp_slip: string,
  cd_io: string
) => {
  try {
    const params = {
      id: "iotype",
      params: {
        cd_firm: global.getState().userInfo.cd_firm,
        cd_module: cd_module,
        fg_slip: fg_slip,
        tp_slip: tp_slip,
        cd_io: cd_io,
      },
    };

    const data = await fnGetTableById(params);

    return data;
  } catch (error) {
    return [];
  }
};
//#endregion

/**
 * configFormat 조회
 * @param nm_column
 */
export const fnGetConfigFormat = async (nm_column: string) => {
  try {
    const params = {
      id: "config_format",
      params: {
        cd_firm: global.getState().userInfo.cd_firm,
        nm_column: nm_column,
      },
    };

    const data = await fnGetTableById(params);

    return data[0].dc_format;
  } catch (error) {
    return [];
  }
};

/**
 * 저장시 라인데이터 확인
 * @param apiH
 * @param apiL
 * @param pks
 */
export const fnLineCheck = (apiH: any, apiL: any, pks: string[]): boolean => {
  try {
    let checkResult = true;
    const allRows: any[] = [];
    apiL.forEachNode((node: any) => {
      allRows.push(node.data);
    });
    apiH.forEachNode((node: any) => {
      const exists = allRows.some((row) =>
        pks.every((pk) => row[pk] === node.data[pk])
      );

      if (!exists) {
        checkResult = false;
      }
    });
    return checkResult;
  } catch (error) {
    return false;
  }
};

export const fnPrint = async (reportName: string, dataJson: any) => {
  const isAgentRunning = async () => {
    try {
      await axios.get("http://localhost:5500/health");
      return true;
    } catch {
      return false;
    }
  };

  const isInstalled = await isAgentRunning();

  if (!isInstalled) {
    const confirm = await showDialog(
      "confirm",
      "자동출력 프로그램이 없습니다. 설치하시겠습니까?"
    );
    if (!confirm) return;

    const res = await axios.get("/snotes/download/PrintAgentSetup", {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = "PrintAgentSetup.exe";
    link.click();

    await showDialog("alert", "설치 후 다시 출력해주세요.");
    return;
  }

  const formData = new FormData();
  formData.append("reportName", reportName);
  formData.append("dataJson", JSON.stringify(dataJson));
  formData.append("ip", `${global.getState().config.SYS0026.dc_ctrl}`);

  const url = "http://localhost:5500/print";
  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const responseText = await response.text();

    if (!response.ok) {
      throw new Error(
        `Print server error: ${response.status} ${response.statusText} ${responseText}`
      );
    }
  } catch (e) {
    console.error(e);
  }
};

// 대소문자 차이가 섞인 report metadata/data 컬럼을 안전하게 읽는다.
const getPrintValue = (data: any, key: string) => {
  if (!data) return undefined;
  const foundKey = Object.keys(data).find(
    (dataKey) => dataKey.toLowerCase() === key.toLowerCase()
  );
  return foundKey ? data[foundKey] : undefined;
};

// cd_report 기준으로 출력 양식 정의와 출력 타입(tp_report)을 조회한다.
const getPrintReportDefinition = async (cdReport: string) => {
  const reportDefs: any = await fnGetDataSet({
    id: "POPUP_REPORT_02",
    params: { cd_report: cdReport },
  });

  return reportDefs?.[0]?.[0];
};

// report 정의의 cd_querys를 실행해 출력 데이터셋을 만든다.
const getPrintReportData = async (cdQuerys: string, printParams: any) => {
  if (!cdQuerys) return {};

  const response = await axios.post(
    "/snotes/getReportDataSet",
    {
      ids: cdQuerys,
      params: printParams,
    },
    {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    }
  );

  return response.data;
};

// 현재 브라우저 환경에 맞는 SmartZPrintAgent 설치 파일명을 선택한다.
const getSmartZPrintAgentFileName = () => {
  const userAgent = window.navigator.userAgent || "";
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

  return isMobile ? "SmartZPrint.Agent.apk" : "SmartZPrint.WindowsAgent.exe";
};

// BE 다운로드 엔드포인트를 통해 SmartZPrintAgent 설치 파일을 내려받는다.
const downloadSmartZPrintAgent = async () => {
  const fileName = getSmartZPrintAgentFileName();
  const res = await axios.get("/snotes/download/PrintAgentSetup", {
    params: { fileName },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
};

// CMDRAW 출력용 SmartZPrintAgent 로컬 서버 상태를 확인한다.
const isSmartZPrintAgentRunning = async () => {
  try {
    const response = await axios.get("http://127.0.0.1:18080/health", {
      timeout: 2000,
    });
    return response?.data?.ok === true || response.status === 200;
  } catch {
    return false;
  }
};

// getReportDataSet 응답 전체를 순회해 ZPL 문자열을 찾는다.
const extractZplFromReportData = (dataJson: any) => {
  const zplKeys = ["zpl", "cmdraw", "dc_zpl", "zpl_payload", "payload"];
  const rows: any[] = [];

  Object.values(dataJson || {}).forEach((dataSet: any) => {
    if (Array.isArray(dataSet)) {
      rows.push(...dataSet);
    }
  });

  for (const row of rows) {
    for (const key of zplKeys) {
      const value = getPrintValue(row, key);
      if (typeof value === "string" && value.trim()) {
        return value;
      }
    }

    const zplLikeValue = Object.values(row || {}).find(
      (value) => typeof value === "string" && value.includes("^XA")
    );
    if (typeof zplLikeValue === "string" && zplLikeValue.trim()) {
      return zplLikeValue;
    }
  }

  return "";
};

// 모바일 브라우저 호환을 위해 form + iframe 방식으로 ZPL을 전송한다.
const postZplToSmartZPrintAgent = (zpl: string) => {
  return new Promise<void>((resolve, reject) => {
    const frameName = `smartzPrintFrame_${Date.now()}`;
    const iframe = document.createElement("iframe");
    iframe.name = frameName;
    iframe.style.display = "none";

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "http://127.0.0.1:18080/print-form";
    form.target = frameName;
    form.style.display = "none";

    const zplField = document.createElement("textarea");
    zplField.name = "zpl";
    zplField.value = zpl;
    form.appendChild(zplField);

    const cleanup = () => {
      window.removeEventListener("message", onMessage);
      iframe.remove();
      form.remove();
      clearTimeout(timeoutId);
    };

    const timeoutId = window.setTimeout(() => {
      cleanup();
      reject(new Error("출력용 Agent 응답 시간이 초과되었습니다."));
    }, 10000);

    const onMessage = (event: MessageEvent) => {
      const message = event.data;
      if (!message || message.source !== "SmartZPrintAgent") return;

      const payload = message.payload;
      if (payload?.type !== "print") return;

      cleanup();
      if (payload.ok) {
        resolve();
      } else {
        reject(new Error(payload.error || "출력용 Agent 출력에 실패했습니다."));
      }
    };

    window.addEventListener("message", onMessage);
    document.body.appendChild(iframe);
    document.body.appendChild(form);
    form.submit();
  });
};

// CMDRAW 리포트는 ZPL을 추출해 SmartZPrintAgent로 TCP RAW 출력을 요청한다.
const fnPrintCmdRaw = async (selectedReport: any, printParams: any) => {
  const isInstalled = await isSmartZPrintAgentRunning();

  if (!isInstalled) {
    const confirm = await showDialog(
      "confirm",
      "출력용 Agent가 없습니다. 설치하시겠습니까?"
    );
    if (!confirm) return;

    await downloadSmartZPrintAgent();
    await showDialog("alert", "설치 후 다시 출력해주세요.");
    return;
  }

  const dataJson = await getPrintReportData(
    getPrintValue(selectedReport, "cd_querys"),
    printParams
  );
  const zpl = extractZplFromReportData(dataJson);

  if (!zpl) {
    throw new Error("ZPL 출력 데이터를 찾을 수 없습니다.");
  }

  await postZplToSmartZPrintAgent(zpl);
};

// cd_report와 출력 파라미터만 받아 report 타입별 출력 흐름을 공통 처리한다.
export const fnPrintByReport = async (cdReport: string, printParams: any) => {
  const selectedReport = await getPrintReportDefinition(cdReport);

  if (!selectedReport?.cd_report) {
    throw new Error("라벨양식 정보를 찾을 수 없습니다.");
  }

  const tpReport = `${getPrintValue(selectedReport, "tp_report") || ""}`
    .trim()
    .toUpperCase();

  if (tpReport === "CMDRAW") {
    return fnPrintCmdRaw(selectedReport, printParams);
  }

  const dataJson = await getPrintReportData(
    getPrintValue(selectedReport, "cd_querys"),
    printParams
  );
  return fnPrint(selectedReport.cd_report, dataJson);
};

export const fnPreview = async (params: any, cd_report?: string) => {
  try {
    if (!params) return;
    if (!cd_report) return;

    const reportDefs: any = await fnGetDataSet({
      id: "POPUP_REPORT_02",
      params: {
        cd_report: cd_report,
      },
    });

    if (!reportDefs?.length || !reportDefs[0]?.length) return;
    const selectedReport = reportDefs[0][0];
    if (!selectedReport?.cd_report) return;

    let dataJson: any = {};
    if (selectedReport.cd_querys) {
      const queryParams = {
        ids: selectedReport.cd_querys,
        params: params,
      };
      const response = await axios.post(
        "/snotes/getReportDataSet",
        queryParams,
        {
          headers: {
            "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
          },
        }
      );
      dataJson = response.data;
    }

    await showPopupModal({
      title: "",
      children: React.createElement(ReportViewer, {
        reportName: selectedReport.cd_report,
        dataJson: dataJson,
      }),
      width: "1400px",
      height: "1000px",
    });
  } catch (error: any) {
    showDialog("error", error.message);
  }
};

export const getBsn = async (
  cd_bsn: string,
  cd_item: string,
  dt: string,
  qt: number,
  seq: number,
  yn_save: string,
  dc_param_exc?: string
): Promise<any | null> => {
  const params = {
    id: "CommonMapper",
    queryId: "getBsn",
    params: {
      cd_firm: global.getState().userInfo.cd_firm,
      cd_bsn: cd_bsn,
      cd_item: cd_item,
      dt: dt,
      qt: qt,
      seq: seq,
      yn_save: yn_save,
      dc_param_exc: dc_param_exc || "",
    },
  };

  try {
    const response = await axios.post("/snotes/getDataSet", params, {
      headers: {
        "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
      },
    });

    // 데이터 유효성 검사 및 안전 반환
    if (response.data && response.data[0]) {
      const rtn = response.data[0][0];

      const lowerRtn = Object.fromEntries(
        Object.entries(rtn).map(([key, value]) => [key.toLowerCase(), value])
      );

      return lowerRtn;
    } else {
      console.error("유효하지 않은 데이터 형식:", response.data);
      return null; // 유효하지 않은 응답 처리
    }
  } catch (error) {
    console.error("API 호출 실패:", error);
    throw error; // 호출부에서 에러를 처리하도록 throw
  }
};

/**
 * 목적: Chip/List 형태의 화면 데이터를 jsonb 배열 저장 구조로 변환한다.
 *
 * 호출 예:
 * toLineJsonArray([{ label: "홍길동" }], "dc_participant")
 * => [{ no_line: 1, dc_participant: "홍길동" }]
 *
 * 사용처:
 * 참석자, 태그처럼 라인번호와 값 컬럼명이 필요한 JSON 배열 payload 생성.
 *
 * @param items 변환 대상 목록
 * @param valueKey 저장 JSON에서 값으로 사용할 key
 * @param options sourceKey, lineKey, startLine 변경 옵션
 * @returns 변환된 배열, 저장할 값이 없으면 undefined
 */
export const toLineJsonArray = <T extends Record<string, any>>(
  items: T[],
  valueKey: string,
  options?: {
    sourceKey?: keyof T;
    lineKey?: string;
    startLine?: number;
  }
) => {
  const sourceKey = options?.sourceKey || "label";
  const lineKey = options?.lineKey || "no_line";
  const startLine = options?.startLine || 1;

  const rows = (items || [])
    .map((item, index) => ({
      [lineKey]: index + startLine,
      [valueKey]: String(item?.[sourceKey] ?? "").trim(),
    }))
    .filter((item) => item[valueKey] !== "");

  return rows.length > 0 ? rows : undefined;
};

/**
 * 목적: 단일 문자열 값을 jsonb 배열 저장 구조로 감싼다.
 *
 * 호출 예:
 * toSingleTextJsonArray("<p>회의록</p>", "txt_minutes")
 * => [{ txt_minutes: "<p>회의록</p>" }]
 *
 * 사용처:
 * Rich editor 본문처럼 화면에서는 문자열 하나로 관리하지만 DB에는 JSON 배열로 저장해야 하는 payload 생성.
 *
 * @param value 변환 대상 문자열
 * @param valueKey 저장 JSON에서 값으로 사용할 key
 * @param options trim false 지정 시 앞뒤 공백을 유지
 * @returns 변환된 배열, 저장할 값이 없으면 undefined
 */
export const toSingleTextJsonArray = (
  value: string,
  valueKey: string,
  options?: {
    trim?: boolean;
  }
) => {
  const text =
    options?.trim === false ? value || "" : String(value || "").trim();
  if (!text) return undefined;

  return [
    {
      [valueKey]: text,
    },
  ];
};

/** * sql서버시간
 * * return to_char(now(), 'YYYY-MM-DD HH24:MI:SS.MS')
 */
export const fnGetDate = async () => {
  const payload = {
    id: "getDate",
    params: {},
  };

  const data = await fnGetTableById(payload);
  return data[0].now;
};
